var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"busca"}},[_c('Banner',{attrs:{"contents":_vm.banner}}),_c('Resultados')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }